import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
import ContentLoader from '../common/ContentLoader';
import PaginationHandler from '../common/PaginationHandler';
class Subthematic extends lm.Composant {
  /**
   * @constructor
   * @param {String} id
   */
  constructor(id) {
    super(id);

    // Init pagination display
    let paginationParam = new URL(document.location).searchParams.get("p");
    scrollInspirationListIntoView();

    // Classic pagination handler
    new PaginationHandler('.js-pagination');
    let sliders = document.querySelectorAll('.o-products__linked-product-slider');
    sliders.forEach(slider => {
      new Carousel("#" + slider.id, {
        centerWhenNoButtons: true
      });
    });
    [...document.querySelectorAll('.mc-carousel:not(.o-products__linked-product-slider)')].forEach(element => {
      new Carousel(element);
    });
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          if (mutation.addedNodes[0].tagName === 'IMG') {
            mutation.addedNodes[0].onload = () => {
              resizer(mutation.target.closest('.o-entry__wrapper'), mutation.target.closest('.js-list'));
            };
          } else {
            delay(() => {
              lm.lazyload.observe();
            }, 100);
          }
        }
      });
    });
    [...document.querySelectorAll('.o-entry__global')].forEach(newImages => {
      observer.observe(newImages, {
        childList: true,
        attributes: true,
        subtree: true
      });
    });
    if (document.querySelector('.js-content-loader')) {
      contentDispatcher();
    }
    const resizeEvents = ['resize', 'orientationchange'];
    resizeEvents.forEach(event => {
      window.addEventListener(event, () => {
        [...document.querySelectorAll('.js-list')].forEach(jsList => {
          delay(() => {
            resizeAll(jsList);
          }, 100);
        });
      });
    });
    const delay = (() => {
      let timer = 0;
      return (callback, ms) => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();
    function resizer(item, parent) {
      const grid = parent;
      const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
      const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      const rowSpan = Math.ceil((item.querySelector('.o-entry__layout').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap) - 0.5);
      item.style.gridRowEnd = `span ${rowSpan}`;
    }
    function resizeAll(parent) {
      const allItems = parent.querySelectorAll('.o-entry__wrapper');
      allItems.forEach(item => {
        resizer(item, parent);
      });
    }

    // Replace elements for loading (legacy infinite scroll path)
    function callback() {
      const showMore = document.querySelector('.js-show-more');
      const content = document.querySelector('.js-content-loader.lazy-loaded');

      // Remove last content loader informations element
      if (content && !showMore) content.remove();

      // Remove Button after first call
      if (showMore) showMore.remove();
      lm.lazyload.observe();
    }
    function contentDispatcher() {
      // First action, click on see more
      document.querySelector('.js-content-loader').addEventListener('click', e => {
        e.preventDefault();
        new ContentLoader(e.target, callback.bind(this));
      });

      // Event sent by lazyload.js
      document.addEventListener('contentLoading', () => {
        delay(() => {
          if (document.querySelector('span.js-content-loader')) {
            new ContentLoader(document.querySelector('span.js-content-loader'), callback.bind(this));
          }
        }, 500);
      });
    }
    function scrollInspirationListIntoView() {
      if (paginationParam) {
        const container = document.querySelector('.js-content-loader-container');
        if (container) container.scrollIntoView();
      }
    }
  }
}
function initSubthematic() {
  new Subthematic('inspirationsubthematic');
}
if (document.readyState === 'loading') {
  globalThis.addEventListener('DOMContentLoaded', initSubthematic);
} else {
  initSubthematic();
}